<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/salesTableF',title:'销售样表(外)'},{title:'新增销售样表'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>新增销售样表</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiaowai">
                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="prodcode">
                                                <el-input placeholder="请输入" v-model="f.prodcode"  @change="selectModel"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="promodel">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.promodel"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="prodseries">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.prodseries" readonly></el-input>
                                                <!--<el-select v-model="f.prodseries" :v="f.prodseries" placeholder="请选择">
                                                    <el-option v-for="(item,index) in LevelName"
                                                               :key="index+1"
                                                               :label="item.levelname"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>-->
                                            </el-form-item>
                                            <!--<el-form-item label="二级分类" class="h-elformWrap-2" prop="procategory">
                                                <el-select v-model="f.procategory" :v="f.procategory" placeholder="请选择">
                                                    <el-option v-for="(item,index) in ProCategory"
                                                               :key="index+2"
                                                               :label="item.levelname"
                                                               :value="item.levelname">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>-->


                                            <el-form-item label="型号经理" class="h-elformWrap-2">
                                                <!--<el-input v-model="f.userCode" ></el-input>-->
                                                <el-input placeholder="请输入工号" v-model="f.userCode" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                                            </el-form-item>
                                       <!--     <el-form-item label="状态" class="h-elformWrap-2" prop="prodstatus">
                                                <brselect category="prodstatus" :v="f.prodstatus" v-model="f.prodstatus"
                                                          :clearable="true"/>
                                            </el-form-item>-->
                                            <el-form-item label="型号属性" class="h-elformWrap-2" prop="protype">
                                                <el-select v-model="f.protype" placeholder="请选择">
                                                    <el-option value="自产">自产</el-option>
                                                    <el-option value="OEM">OEM</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
                                                <el-input placeholder="定价后自动带出" v-model="f.factory" disabled></el-input>
                                            </el-form-item>

                                            <el-form-item label="有效期" class="h-elformWrap-2" prop="validperiod">
                                                <el-date-picker placeholder="请选择"
                                                                v-model="f.validperiod"
                                                                value-format="yyyy-MM-dd"
                                                                :clearable="false"
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                          <el-form-item label="是否增值服务" class="h-elformWrap-2" prop="isValueAddedService">
                                            <el-select v-model="f.isValueAddedService" :v="f.isValueAddedService" placeholder="请选择">
                                              <el-option v-for="(item) in fwList"
                                                         :key="item.code"
                                                         :label="item.name"
                                                         :value="item.code">
                                              </el-option>
                                            </el-select>
                                          </el-form-item>
											<el-form-item label="区域" class="h-elformWrap-2 w-elformWrap" prop="areacodelist">
											<!--
											                                                <brselectlazy :multiple="true" category="neibu_haiwai_area" :v="f.areacode" v-model="f.areacode" style="width:3.2rem"/>
											-->
												<el-select :multiple="true" v-model="f.areacodelist" placeholder="请选择" @change="selectAll">
													<el-option
															v-for="item in options"
															:key="item.value"
															:label="item.label"
															:value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveS">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'

    export default {
        data() {
            return {
                //带线表单
                f: {
                    procategory: '',
                    areacodelist:[],
                    isValueAddedService:0,
                },
                queryq: {
                    oneLid: '',
                    materialCode:'',
                },
                LevelName: [],
                ProCategory: [],
                options: [{
                    value: 'all',
                    label: '全选'
                }],
                rules: {
                    prodcode: [{required: true, message: '请填写产品编码', trigger: 'blur'}],
                   /* prodstatus: [{required: true, message: '请选择状态', trigger: 'change'}],*/
                    protype: [{required: true, message: '请选择型号属性', trigger: 'change'}],
                    areacodelist: [{required: true, message: '请选择区域', trigger: 'change'}],
                    validperiod: [{required: true, message: '请选择有效期', trigger: 'change'}],
                   /* factory: [{required: true, message: '请选择产地名称', trigger: 'change'}],*/
                },
                fwList:[
                  {code:1,name:"是"},
                  {code:0,name:"否"}
                ],
            }
        },
        created() {
            var area = this.$store.getters.dictlist("neibu_haiwai_area");
            for (var i = 0; i < area.length; i++) {
                var opt = {
                    value: area[i].code,
                    label: area[i].name
                };
                this.options.push(opt)
            }
            this.showLevelName();
        },
        methods: {
            selectAll(v) {
                for(var j = 0; j < v.length; j++){
                    if (v[j] == 'all') {
                        if (this.f.areacodelist.length == this.options.length) {
                            this.f.areacodelist = []
                        } else {
                            this.f.areacodelist = []
                            for (var i = 0; i < this.options.length; i++) {
                                if (this.options[i].value != 'all') {
                                    this.f.areacodelist.push(this.options[i].value);
                                }
                            }
                        }
                    }
                }
            },
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            //返回
            backS() {
                this.$router.push({path: "/chanp/salesTableF"});
            },
            //保存
            saveS() {
                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    this.$msg.confirm("确认提交该信息获取?", () => {
                        for (var i = 0; i < this.LevelName.length; i++) {
                            if (this.LevelName[i].id == this.f.prodseries) {
                                this.f.oneLid = this.LevelName[i].id;
                                this.f.prodseries = this.LevelName[i].levelname;
                            }
                        }
                        this.f.areacode = this.f.areacodelist.join(",");
                        this.f.areacodelist = [];
                        console.log(this.f,"我看看最后结果");
                        ss.salesListF.saveS(this.f).then(rd => {
                            this.$router.push({path: "/chanp/salesTableF"});
                        })
                    });
                }
            },
            selectModel(code) {
                ss.salesListF.selectModel(code).then(rd => {
                    if(rd){
                        this.$msg.msgs("该物料在销售样表中已存在,样表信息将自动带出");
                        this.f = rd;
                        this.f.id='';
                        this.f.areacodelist = rd.areacode.split(',');
                    }else{
                        this.f = { "prodcode": code};
                        this.$refs.f.resetFields();
                        this.selectListByCode(code)
                    }


                })
            },
            //根据根据编码查询物料信息
            selectListByCode(code) {
                this.queryq.materialCode = code
                ss.chanpin.selectListByCode(this.queryq).then(rd => {
                    if(rd){
                        this.f.promodel = rd.materialDescrition;
                        if(rd.materialType=='HAWA'){
                            this.f.protype='OEM'
                        }else if (rd.materialType=='FERT' || rd.materialType=='ROH' || rd.materialType=='HALB'){
                            this.f.protype='自产'
                        }
                        for (var i = 0; i < this.LevelName.length; i++) {
                            if (rd.productHierarchy.startsWith(this.LevelName[i].id)){
                                this.f.oneLid = this.LevelName[i].id;
                                this.f.prodseries = this.LevelName[i].levelname;
                            }
                        }
                        //如果是OEM并且不是离心机产品外销销售样表产地都是9393
                        if(this.f.protype=='OEM' && this.f.oneLid !='NA7'){
                            this.f.factory = '9393';
                        }else{
                            this.f.factory = rd.factory;
                        }


                    }else{
                        this.$msg.msge("物料编码错误！");
                        this.f.promodel = '';
                        this.f.oneLid ='';
                        this.f.prodseries ='';
                    }
                    this.$forceUpdate();
                })


            },
        }
    }
</script>
<style>
    .Yangbiaowai .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .Yangbiaowai .el-form-item__content {
        width: 69%;
    }

    .Yangbiaowai .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem
    }

    .Yangbiaowai .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiaowai .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .Yangbiaowai .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }

    .Yangbiaowai.el-form-item__content .el-select {
        width: 100%;
    }
	.Yangbiaowai .w-elformWrap {
		width: 100% !important;
	}
	.w-elformWrap .el-form-item__label {
		width: 10% !important;
	}
	.w-elformWrap .el-form-item__content {
		width: 90% !important;
	}
</style>
